import _ from "lodash";
import ViewBase from "../view-base.view";
import HomeDashboardModel from "../../models/home/home-dashboard.model";
import Sortable from 'sortablejs';
import { Button, Switch, Intent } from "construct-ui";

export default function DashboardSettingsView() {

  ViewBase.call(this);

  let widgetList = [];
  let sortable;
  let isUpdated = false;

  let triggerRefresh = (isUpdated, updatedWidgetList) => { }

  let onClose = (e) => { }

  let getWidgetLayoutSettings = () => {
    this.showLoading();
    HomeDashboardModel.getHomeWidgetLayoutSettings(
      (result) => {
        widgetList = result;
        this.hideLoading();
      },
      (error) => {
        this.hideLoading();
        this.handleError(error);
      }
    );
  }

  let saveWidgetLayoutSettings = () => {
    this.showLoading();
    HomeDashboardModel.updateHomeWidgetLayoutSettings(
      (result) => {
        isUpdated = true;
        this.hideLoading();
        onClose(false);
      },
      (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      widgetList
    );
  }

  let saveButtonClicked = () => {
    // Update widget sequences
    let currentSequenceList = sortable.toArray();
    let hasMissingWidget = false;

    widgetList.forEach(w => {
      let idIndex = currentSequenceList.findIndex(id => w.widgetMstID.toString() === id);
      if (idIndex > -1) {
        w.sequence = String(idIndex + 1);
      } else {
        // Error - original widget is missing from the list
        hasMissingWidget = true;
      }
    });

    if (hasMissingWidget) {
      // [CV] TODO: handle error
    } else {
      // Attempt to save
      saveWidgetLayoutSettings();
    }
  }

  let cancelButtonClicked = () => {
    onClose(false);
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }
      if (vnode.attrs.triggerRefresh) {
        triggerRefresh = vnode.attrs.triggerRefresh;
      }
      getWidgetLayoutSettings();
    },
    onremove: () => {
      triggerRefresh(isUpdated, widgetList);
    },
    oncreate: () => {
      // Enable Sortable
      var wList = document.getElementById('widgetConfigList');
      sortable = new Sortable(wList, {
        animation: 150,
        ghostClass: 'sortable-ghost',
        dragClass: 'sortable-drag',
        handle: '.drag-grip',
      });
    },
    view: (vnode) => {
      return [
        m('.container',
          m('ul.list-group#widgetConfigList.my-3',
            widgetList.map(w => [
              m('li.list-group-item', { 'data-id': w.widgetMstID },
                m('.d-flex.justify-content-between.align-items-stretch.flex-nowrap', { style: "min-height: 36px;" },
                  m('.d-flex.align-items-center.flex-nowrap.flex-grow-1.drag-grip',
                    m('i.bi.bi-grip-vertical.me-3'),
                    w.widgetName
                  ),
                  m('.d-flex.align-items-center.flex-nowrap',
                    m(Switch, {
                      checked: w.status === '001',
                      intent: Intent.PRIMARY,
                      label: 'Show',
                      onchange: (e) => {
                        if (e.target.checked) {
                          w.status = '001';
                        } else {
                          w.status = '002';
                        }
                      }
                    })
                  ),
                )
              )
            ])
          ),
          m('.d-flex.justify-content-center.align-items-center.flex-nowrap.my-3', {
            style: 'gap: 12px;'
          },
            m(Button, {
              intent: Intent.PRIMARY,
              label: 'Save',
              onclick: saveButtonClicked,
            }),
            m(Button, {
              label: 'Cancel',
              onclick: cancelButtonClicked,
            })
          )
        )
      ];
    }
  }
}
//